import { useRef } from 'react';

export function useLocalStorageRef(key: string) {
  const value = useRef<string | null>(window.localStorage.getItem(key) || null);
  const ref = useRef({
    value: () => value.current,
    update: (next: string | null) => {
      value.current = next;

      setTimeout(() => {
        if (typeof next === 'string') {
          window.localStorage.setItem(key, next);
        } else {
          window.localStorage.removeItem(key);
        }
      }, 0);
    }
  });

  return ref.current;
}
